import React from "react";

const SmallText: React.FC<{ class?: string }> = props => {
  return <span className={`text-sm text-center ${props?.class}`}>{props?.children}</span>;
};

export default SmallText;
